import { Box, Stack, Typography, Paper, Avatar } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import axiosInstance from "../../utils/axiosInstance";
import { statusUrl } from "../../utils/urls";
import InfoIcon from "@mui/icons-material/Info"; // Example icon
import PageHeader from "../../components/page-layout/PageHeader";
import LoadingUI from "../../components/LoadingUI";

const Status = () => {
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  const [rows, setRows] = useState([]);

  useEffect(() => {
    axiosInstance
      .get(statusUrl)
      .then((res) => {
        const formatted = res.data.map((status) => ({
          ...status,
          name: status.name.trim(),
          id: status.id || Math.random().toString(),
        }));
        setRows(formatted);
      })
      .finally(() => setIsLoading(false));
  }, []);

  return (
    <Stack spacing={2}>
      <PageHeader
        title="Status with Descriptions"
        lead="Below is a list of all system statuses and their descriptions. Use this information to understand the current state of various processes."
        showBack={true}
      />
      {isLoading ? (
        <LoadingUI />
      ) : (
        <Stack spacing={3}>
          {rows.map((row) => (
            <Paper
              key={row.id}
              elevation={1}
              sx={{
                display: "flex",
                alignItems: "center",
                p: 3,
                gap: 3,
                borderRadius: 2,
              }}
            >
              <Avatar sx={{ bgcolor: "primary.main", width: 32, height: 32 }}>
                <InfoIcon fontSize="large" />
              </Avatar>
              <Box>
                <Typography variant="body1" fontWeight={700}>
                  {row.name}
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  {row.description}
                </Typography>
              </Box>
            </Paper>
          ))}
        </Stack>
      )}
    </Stack>
  );
};

export default Status;
